/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import BASE_REPORT from '../BaseComponent/BASEREPORT'

class AddCar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      carType: []
    }
  }

  componentDidMount() {
    const token = sessionStorage.getItem('accessToken')

    http
      .get(`${BASE_REPORT.BASE_REPORT_CAR}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            carType: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  addCar() {
    let carTypeId = document.getElementById('carTypeId').value
    let code = document.getElementById('code').value
    let color = document.getElementById('color').value
    let year = document.getElementById('year').value
    let capacity = document.getElementById('capacity').value
    let plateNumber = document.getElementById('plateNumber').value
    let plateText = document.getElementById('plateText').value
    var carTypeError = false
    var codeError = false
    var colorError = false
    var yearError = false
    var capacityError = false
    var plateNumberError = false
    var plateTextError = false
    var formError = false

    if (carTypeId == '') {
      carTypeError = true
      formError = true
      message.error('نوع خودرو را وارد کنید')
    } else {
      if (!carTypeId) {
        this.setState({
          error: ''
        })
      }
    }
    if (code == '') {
      codeError = true
      formError = true
      message.error('یک کد برای خودرو وارد کنید')
    } else {
      if (!codeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (color == '') {
      colorError = true
      formError = true
      message.error('رنگ خودرو را تعیین کنید')
    } else if (!color.match(/[\u0600-\u06FF]/g)) {
      colorError = true
      formError = true
      message.error('رنگ خودرو را به فارسی تعیین کنید')
    } else {
      if (!colorError) {
        this.setState({
          error: ''
        })
      }
    }
    if (year == '') {
      yearError = true
      formError = true
      message.error('مدل خودرو را وارد کنید')
    } else {
      if (!yearError) {
        this.setState({
          error: ''
        })
      }
    }
    if (capacity == '') {
      capacityError = true
      formError = true
      message.error('ظرفیت خودرو را وارد کنید')
    } else {
      if (!capacityError) {
        this.setState({
          error: ''
        })
      }
    }
    if (plateNumber == '') {
      plateNumberError = true
      formError = true
      message.error('بخش سمت راست پلاک را وارد کنید')
    } else if (!plateNumber.match(/[1-9\d]{2}/g)) {
      plateNumberError = true
      formError = true
      message.error('بخش سمت راست پلاک خودرو باید شامل دو عدد باشد')
    } else {
      if (!plateNumberError) {
        this.setState({
          error: ''
        })
      }
    }

    if (plateText == '') {
      plateTextError = true
      formError = true
      message.error('بخش سمت چپ پلاک را وارد کنید')
    } else if (!plateText.match(/[1-9\d]{2}[\u0600-\u06FF][1-9\d]{3}/g)) {
      plateTextError = true
      formError = true
      message.error('فرمت پلاک باید به صورت 88ج 888 باشد')
    } else {
      if (!plateTextError) {
        this.setState({
          error: ''
        })
      }
    }

    // [1-9\d]{2}[\u0600-\u06FF][1-9\d]{3}

    if (!formError) {
      const token = sessionStorage.getItem('accessToken')

      let data = {
        carTypeId: +carTypeId,
        code: +this.convertDigit(code),
        color: color,
        year: +this.convertDigit(year),
        capacity: +this.convertDigit(capacity),
        plateNumber: +this.convertDigit(plateNumber),
        plateText: plateText
      }
      http
        .post(`car/manage/add`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            message.success('خودروی جدید اضافه شد,لطفا صبر کنید')
            setInterval(() => {
              window.location.assign('/allCars')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/allCars'}>خودرو ها</Link>
            </li>
            <li>ثبت خودرو</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت خودرو</p>
            </div>
            <div className="formComponent">
              <label>
                نوع خودرو <span className="requireFiled">*</span>
              </label>

              <select className="form-control" id="carTypeId">
                <option value="">نوع خودرو</option>
                {this.state.carType.map((carType, index) => (
                  <option key={index} value={carType.id}>
                    {carType.name}
                  </option>
                ))}
              </select>
              <label>
                کد خودرو <span className="requireFiled">*</span>
              </label>
              <input type="text" id="code" className="form-control" />

              <label>
                رنگ خودرو <span className="requireFiled">*</span>
              </label>
              <input type="text" id="color" className="form-control" />

              <label>
                مدل خودرو <span className="requireFiled">*</span>
              </label>
              <input type="number" id="year" className="form-control" />

              <label>
                ظرفیت خودرو <span className="requireFiled">*</span>
              </label>
              <input type="number" id="capacity" className="form-control" />

              <div className="plate">
                <div className="plateNumber">
                  <input type="text" id="plateNumber" maxLength="2" />
                </div>

                <div className="plateText">
                  <input type="text" id="plateText" maxLength="6" />
                </div>
              </div>

              <button className="btn btn-info btn-block" onClick={this.addCar.bind(this)}>
                ثبت خودروی جدید
              </button>

              {<p className="errorText">{this.state.error}</p>}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddCar
